import { render } from "./AdminPlatformContractDrawer.vue?vue&type=template&id=34a3f9eb&scoped=true"
import script from "./AdminPlatformContractDrawer.vue?vue&type=script&lang=js"
export * from "./AdminPlatformContractDrawer.vue?vue&type=script&lang=js"

import "./AdminPlatformContractDrawer.vue?vue&type=style&index=0&id=34a3f9eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a3f9eb"]])

export default __exports__